import { AxiosError } from 'axios';
import { isRouteErrorResponse } from 'react-router-dom';
import { z } from 'zod';

export function getErrorMessage(error: unknown) {
  if (!error) {
    return;
  }

  console.error(error);

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return 'Questa pagina non esiste!';
    }

    if (error.status === 401 || error.status === 403) {
      return 'Non sei autorizzato!';
    }

    if (error.status === 503) {
      return 'Il servizio non è momentaneamente disponibile!';
    }
  }

  if (error instanceof z.ZodError) {
    // const errors = error.issues.map((issue) => {
    //   return issue.message;
    // });
    // return errors.join('\n');
    return error.toString();
  }

  if (error instanceof AxiosError) {
    const message =
      error.response?.data?.detail ||
      error.response?.data?.error?.msg ||
      error.response?.data;

    if (message) {
      return message;
    }

    if (error.response?.status === 404) {
      return 'Elemento non trovato!';
    }

    if (error.response?.status === 401 || error.response?.status === 403) {
      return 'Non sei autorizzato!';
    }

    if (error.response?.status === 503) {
      return 'Il servizio non è momentaneamente disponibile!';
    }

    return 'Si è verificato un errore';
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'Qualcosa è andato storto!';
}
